module.exports = "/images/vendor/flag-icon-css/flags/4x3/pl.svg?562edca5bb39d66f4c9238a36295187b";